import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const DemoSetup = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const name = searchParams.get("name");
    const email = searchParams.get("email");
    if (name && email) {
      navigate("/online-demo/wait");
    } else {
      navigate("/not-found");
    }
  }, [searchParams, navigate]);

  return null;
};

export default DemoSetup;
